import { queryClient } from "./queryClient";

/**
 * Clear all booking-related cache on logout.
 * Prevents deleted/paid bookings from reappearing after session clear.
 */
export const clearBookingCache = () => {
  queryClient.removeQueries({ queryKey: ["bookings"] });
  queryClient.removeQueries({ queryKey: ["my-bookings"] });
  queryClient.removeQueries({ queryKey: ["host-bookings"] });

  try {
    localStorage.removeItem("berastays_last_booking");
    localStorage.removeItem("berastays_booking_draft");
    sessionStorage.removeItem("berastays_last_booking");
  } catch (e) {
    console.error("Error clearing booking storage:", e);
  }

  console.log("[Cache] Booking cache cleared");
};
